<template>
<section>
  <v-parallax v-bind:src="require('../../assets/pictures/Gaestebuch.jpg')"
    height="600">
    <v-layout
      column
      align-center
      justify-center
      class="white--text"
    >
      <img
        class="mt-5"
        src="../../assets/pictures/Teutonia_Zirkel_transparent_black.png"
        height="230"
      >
      <h1 class="black--text mb-2 display-1 text-xs-center">TWV Teutonia</h1>
      <div class="black--text subheading mb-3 text-xs-center">Per Aspera ad Astra!</div>

    </v-layout>
  </v-parallax>
   <!-- <div class="red darken-4 text-xs-center">
    <h2 class="headline">
      Für den Weihnachtscommers am 02.12.22 wird um Anmeldung gebeten. <a href="https://docs.google.com/forms/d/e/1FAIpQLSeQ2tj7xuxY6jvqeVMuK4gG6RMejdeu9PNK3y3u-vYaBFIWIQ/viewform?usp=sf_link">Zur Anmeldung</a>
    </h2>
  </div> -->
</section>
</template>

<script>

export default {

  data: () => ({
  }),
};
</script>
